<app-base-modal [isOpen]="isOpen" (close)="onClose()">
  <!-- <app-base-modal [isOpen]="true"> -->
  <h1 header class="buy-client-number-modal__title">Choose new fax number</h1>

  <app-search-telnyx-number-form
    [selectedNumber]="selectedNumber"
    (selectNumber)="selectNumber($event)"
  ></app-search-telnyx-number-form>

  <p class="buy-client-number-modal__transfer-title">
    It's easy to transfer (port) your existing fax number to SipSignal.
  </p>

  <p class="buy-client-number-modal__transfer-description">
    We will assigned you an initial fax number. Once your purchase is complete and your account is activated,
    you will be able to initiate the transfer by login into your account and going to the Admin Portal-> Phone
    System configuration tab.
    <br />
    You can also contact our sales at 718-975-1919 for more details.
  </p>

  <p *ngIf="errorMessage" class="buy-client-number-modal__error" role="alert">{{ errorMessage }}</p>

  <button
    class="btn_primary btn_lg buy-client-number-modal__submit-button"
    [disabled]="isSubmitDisabled"
    (click)="onSubmit()"
  >
    Buy
  </button>
</app-base-modal>
